<template>
    <v-container class="text-center">
        <h1>Progress View</h1>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
    mounted() {
        // this.setLayout("login-layout");
        this.setLayout("main-layout");
    },
    computed: {
        ...mapGetters({
            layout: "getLayout"
        })
    },
    methods: {
        ...mapActions({
            setLayout: "setLayout"
        })
    }
};
</script>
